export var PrescriptionFrequency;
(function (PrescriptionFrequency) {
    PrescriptionFrequency["ONCE_WEEKLY"] = "1 x w\u00F6chentlich";
    PrescriptionFrequency["ONE_TO_TWO_WEEKLY"] = "1 - 2 x w\u00F6chentlich";
    PrescriptionFrequency["ONE_TO_THREE_WEEKLY"] = "1 - 3 x w\u00F6chentlich";
    PrescriptionFrequency["TWICE_WEEKLY"] = "2 x w\u00F6chentlich";
    PrescriptionFrequency["TWO_TO_THREE_WEEKLY"] = "2 - 3 x w\u00F6chentlich";
    PrescriptionFrequency["THREE_TIMES_WEEKLY"] = "3 x w\u00F6chentlich";
    PrescriptionFrequency["EVERY_2_WEEKS"] = "alle 2 Wochen";
    PrescriptionFrequency["EVERY_4_WEEKS"] = "alle 4 Wochen";
    PrescriptionFrequency["EVERY_4_TO_6_WEEKS"] = "alle 4 - 6 Wochen";
    PrescriptionFrequency["EVERY_6_WEEKS"] = "alle 6 Wochen";
})(PrescriptionFrequency || (PrescriptionFrequency = {}));
//# sourceMappingURL=prescription-frequency.enum.js.map